export default __webpack_public_path__ + "static/media/gtzLogo.0b8890ae.svg";